var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseListV2',{attrs:{"model-class":_vm.Role,"collection-filter":_vm.filter,"has-life-cycle":false,"help-message":'Roles are used to grant a set of rule permissions to users.'}})}
var staticRenderFns = []

export { render, staticRenderFns }